import { Box, Button } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useRef } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import ErrorGroup from "areas/product/error-group"
import {
  diamondStartOver,
  toggleBuildYourOwn,
} from "areas/product/store/actions"

import AdditionalInfo from "./additional-info"
import CaratOptions from "./carat-options"
import ChooseGemstones from "./choose-gemstones"
import ChooseStone from "./choose-stone"
import ChooseStoneTypes from "./choose-stone-types"
import FinalDiamond from "./final-diamond"
import Heading from "./heading"
import Navigation from "./navigation"
import ShapeOptions from "./shape-options"

const Container = styled(Box).attrs((props) => ({
  mb: 3,
  px: 2,
  ...props.theme.diamondSelector.container,
}))``

const StartOver = styled(Button).attrs((props) => ({
  color: "primary",
  fontSize: "14px",
  variant: "text",
  ...props.theme.diamondSelector.startOver,
}))`
  height: 16px;
  margin-bottom: 12px;
  text-decoration: underline;
`
const ReturnRec = styled(Button).attrs({
  variant: "text",
})`
  color: ${(props) => props.theme.colors.primary};
  display: block;
  font-size: 16px;
  margin: 32px auto 24px;
  text-decoration: underline;
`

const InternalDiamondSelector = ({
  currentStepIndex,
  currentStepName,
  diamondLoaded,
  errorText,
  returnToRec,
  startOver,
}) => {
  if (!diamondLoaded) {
    return null
  }
  const diamondSelectorRef = useRef(null)
  const chooseStone = <ChooseStone />
  const infoComponent = <AdditionalInfo />

  let content
  let additionalInfo
  switch (currentStepName) {
    case "choose_stone_type":
      content = <ChooseStoneTypes />
      break
    case "choose_gemstone":
      content = <ChooseGemstones />
      additionalInfo = infoComponent
      break
    case "d_shape":
      content = <ShapeOptions />
      break
    case "d_carat":
      content = <CaratOptions />
      break
    case "choose_stone":
      content = chooseStone
      additionalInfo = infoComponent
      break
    case "d_cut":
    case "d_color":
    case "d_clarity":
      content = chooseStone
      additionalInfo = (
        <>
          {infoComponent}
          <ReturnRec onClick={() => returnToRec()}>
            Return To Recommendations
          </ReturnRec>
        </>
      )
      break
    case "confirm_stone":
      content = chooseStone
      break
    case "confirm_gemstone":
    case "final_diamond":
      content = <FinalDiamond step={currentStepName} />
      break
  }
  return (
    <Container
      pt={currentStepIndex === 0 ? "28px" : 0}
      ref={diamondSelectorRef}
    >
      {currentStepIndex > 0 && (
        <StartOver
          data-cy="diamon-selector-start-over"
          onClick={() => startOver()}
        >
          Start Over
        </StartOver>
      )}
      {errorText && <ErrorGroup>{errorText}</ErrorGroup>}

      <Heading />
      <Box mt={3}>{content}</Box>

      <Navigation diamondSelectorRef={diamondSelectorRef} />
      {additionalInfo}
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    currentStepIndex: state.diamondUI.currentStep,
    currentStepName: state.diamondUI.steps[state.diamondUI.currentStep],
    diamondLoaded: state.diamondSelector.diamondLoaded,
    errorText: state.choices.s1?.error,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    returnToRec: () => {
      dispatch(toggleBuildYourOwn())
    },
    startOver: () => {
      dispatch(diamondStartOver())
    },
  }
}

InternalDiamondSelector.propTypes = {
  currentStepIndex: PropTypes.number,
  currentStepName: PropTypes.string,
  diamondLoaded: PropTypes.bool,
  errorText: PropTypes.string,
  returnToRec: PropTypes.func,
  startOver: PropTypes.func,
}

const DiamondSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDiamondSelector)

export default DiamondSelector
